import axios from 'axios';

export default {
  namespaced: true,

  state: {
    status: {
      isLoggedIn: false,
    },
    userToken: null,
    user: null,
  },

  getters: {
    authUser(state) {
      return state.user ? state.user : null;
    },

    isLoggedIn(state) {
      return state.status.isLoggedIn ? state.status.isLoggedIn : false;
    },
  },

  actions: {
    initAuthentication({ state, dispatch, commit }) {
      return new Promise((resolve, reject) => {
        const token = state.userToken || localStorage.getItem('userToken');
        if (token) {
          dispatch('fetchAuthUser', token).then((user) => {
            commit('SET_LOGIN_SUCCESS', token);
            dispatch('setUserOnLogin', {}, { root: true });
            resolve(user);
          }).catch((error) => {
            console.log('this is the error message', error.response);
            if (error.response && error.response.data.message === 'jwt expired') {
              commit('SET_LOGIN_FAIL');
              localStorage.removeItem('userToken');
            } else {
              commit('SET_LOGIN_FAIL');
            }
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    },

    login({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env.VUE_APP_AXIOS_URI_BASE}/auth/login`, {
            username: user.username,
            password: user.password,
          })
          .then((response) => {
            const loginToken = response.data?.token;
            if (loginToken) {
              localStorage.setItem('userToken', loginToken);
              commit('SET_LOGIN_SUCCESS', loginToken);
              dispatch('setUserOnLogin', {}, { root: true });
              resolve(loginToken);
            } else {
              commit('SET_LOGIN_FAIL');
              resolve(false);
            }
          }).catch((err) => {
            reject(err);
          });
      });
    },

    signUp({ dispatch }, user) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env.VUE_APP_AXIOS_URI_BASE}/auth/signup`, {
            ...user,
          })
          .then((createdUser) => {
            dispatch('login', user).then(() => {
              resolve(createdUser);
            });
          }).catch((err) => {
            reject(err);
          });
      });
    },

    logout({ commit, dispatch }) {
      return new Promise((resolve) => {
        commit('SET_LOGOUT');
        dispatch('CleanUpUserOnLogout', {}, { root: true });
        localStorage.removeItem('userToken');
        resolve(true);
      });
    },

    fetchAuthUser({ commit }, token) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.VUE_APP_AXIOS_URI_BASE}/auth/me`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }).then((response) => {
            commit('SET_USER_PROFILE', response.data);
            resolve(response.data);
          }).catch((error) => {
            reject(error);
          });
      });
    },
  },

  mutations: {
    SET_LOGIN_SUCCESS(state, token) {
      state.status.isLoggedIn = true;
      state.userToken = token;
    },
    SET_LOGIN_FAIL(state) {
      state.status.isLoggedIn = false;
      state.userToken = null;
    },

    SET_LOGOUT(state) {
      state.status.isLoggedIn = false;
      state.user = null;
      state.userToken = null;
    },

    SET_USER_PROFILE(state, payload) {
      state.user = payload;
    },
  },
};
